// Newsletter Popup Error - Convertido de jQuery para vanilla JS

(function() {
  function initNewsletterError() {
    if (window.location.href.indexOf('newsletter&form_type=customer') > -1) {
      const popup = document.querySelector('.newsletter-success-modal');
      if (!popup) return;

      const close = popup.querySelector('.close');
      const success = popup.querySelector('.success');
      const error = popup.querySelector('.error');
      const overlay = document.querySelector('.background-overlay');

      // Mostrar popup e overlay
      popup.style.display = 'block';
      if (overlay) overlay.style.display = 'block';
      if (error) error.style.display = 'block';
      if (success) success.style.display = 'none';

      // Cookie helper
      function setCookie(name, value, days) {
        const d = new Date();
        d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
        const expires = "expires=" + d.toUTCString();
        document.cookie = name + "=" + value + ";" + expires + ";path=/";
      }

      setCookie('emailSubcribeModal', 'closed', 1);

      // Fechar popup
      function closePopup() {
        popup.style.display = 'none';
        if (overlay) overlay.style.display = 'none';
      }

      if (close) {
        close.addEventListener('click', closePopup);
      }

      if (overlay) {
        overlay.addEventListener('click', closePopup);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNewsletterError);
  } else {
    initNewsletterError();
  }
})();
